export default __webpack_public_path__ + "static/media/ic-second-grade.9d7c1b3f.svg";